import { render, staticRenderFns } from "./IdolNoteModal.vue?vue&type=template&id=4c8c27ba&"
import script from "./IdolNoteModal.vue?vue&type=script&lang=ts&"
export * from "./IdolNoteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports